// Shared labels for case study and blog post pages (breadcrumb, badges, closing CTA).

const en = {
  breadcrumbContent: 'Content',
  caseStudy: 'Case Study',
  blog: 'Blog',
  techStack: 'Technology stack',
  whatWasBuilt: 'What Was Built',
  whatChanged: 'What changed',
  roadmapHighlights: 'Roadmap Highlights',
  keyMilestone: 'Key Milestone',
  closingLine: 'If that sounds familiar, we are worth a conversation.',
  backToContent: '← Back to Content',
  ctaSimilarProject: 'Start a similar project',
  ongoing: 'Ongoing',
  cooperationSince: (year: string) => `Cooperation since ${year}`,
};

const sk: typeof en = {
  breadcrumbContent: 'Obsah',
  caseStudy: 'Prípadová štúdia',
  blog: 'Blog',
  techStack: 'Technológie',
  whatWasBuilt: 'Čo sme postavili',
  whatChanged: 'Čo sa zmenilo',
  roadmapHighlights: 'Míľniky',
  keyMilestone: 'Kľúčový míľnik',
  closingLine: 'Ak vám to znie povedome, oplatí sa nám porozprávať.',
  backToContent: '← Späť na obsah',
  ctaSimilarProject: 'Začnime podobný projekt',
  ongoing: 'Prebieha',
  cooperationSince: (year: string) => `Spolupráca od roku ${year}`,
};

export const caseStudyChromeCopy = { en, sk };
